import { render, staticRenderFns } from "./ReminderHistory.vue?vue&type=template&id=4a43968b"
import script from "./ReminderHistory.vue?vue&type=script&lang=js"
export * from "./ReminderHistory.vue?vue&type=script&lang=js"
import style0 from "./ReminderHistory.vue?vue&type=style&index=0&id=4a43968b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports